/* @flow weak */

'use strict';

const _ = require('lodash');
const Reflux = require('reflux');
const ProductActions = require('../actions/ProductActions.jsx');

const PartActions = require('../actions/PartActions.jsx');
const QuestionActions = require('../actions/QuestionActions.jsx');
const Loader = require('../loaders');

const ProductStore = Reflux.createStore({
  listenables: [ProductActions],

  data: {},

  getInitialState() {
    return this.data;
  },

  onLoad(data) {
    this.data = data;

    this.trigger(this.data);
  },

  getData() {
    return this.data;
  },

  getItemCode() {
    return _.get(this.data, 'metadata.ItemCode');
  },

  getSKUMap() {
    return _.get(this.data, 'metadata.SKU');
  },

  getGreekRoyalty() {
    return _.get(this.data, 'metadata.Pricing.GreekRoyalty');
  },

  getProductId() {
    return this.data.id;
  },

  getProductName() {
    const ln = Loader.ln || 'en_US';
    return _.get(this.data, `metadata.lang.${ln}.DisplayName`) || this.data.name;
  },

  getSchoolId() {
    return this.data.school_id;
  },

  getSchoolName() {
    return this.data.school_name;
  },

  getSchoolCode() {
    return this.data.school_code;
  },

  getSchoolCountry() {
    return _.isString(this.data.school_country) && _.trim(this.data.school_country) 
      ? this.data.school_country.toUpperCase() 
      : this.data.school_country;
  },

  getSmi() {
    return _.get(this.data, 'smi');
  },

  getProductLineId() {
    return this.data.productline_id;
  }
});

module.exports = ProductStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/ProductStore.jsx